import React from 'react'

interface IGoogleMapsProps {
    url: string,
}

export default function GoogleMap(props: IGoogleMapsProps) {

    const { url } = props

    if (!url){
        return <></>
    }

    return(
        <div className="google-map-embded-container">
            <div className="content-of-google-map-embded-container">
                <iframe 
                    src={url}
                    width="100%" 
                    height="450" 
                    allowFullScreen
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"
                >
                </iframe>
            </div>
        </div>
    )
}